<template>
  <div class="layout">
    <div class="inner">
      <div v-if="!isMobile" class="characteristic-box">
        <div class="animated fadeInDown slow">
          <div class="title">特色面试功能</div>
          <div class="subtitle">简单、易用的面试助手</div>
        </div>
        <div class="lists">
          <div class="list animated fadeInLeft slow">
            <div class="left">
              <img src="@/static/images/interview-2-1.png" />
            </div>
            <div class="pcRight">
              <div class="top">无需安装任何软件</div>
              <div class="font-16">
                面试官和候选人都无需安装任何软件<br />
                直接打开链接或扫描二维码<br />
                即可进入面试房间
              </div>
            </div>
          </div>
          <div class="list animated fadeInRight slow">
            <div class="left">
              <img src="@/static/images/interview-2-2.png" />
            </div>
            <div class="pcRight">
              <div class="top">一键自助安排面试</div>
              <div class="font-16">
                面试后台一键导入面试名单<br />
                批量安排候选人，批量设置面试规则<br />
                无缝对接简历系统
              </div>
            </div>
          </div>
          <div class="list animated fadeInLeft slow" style="padding-top: 20px">
            <div class="left">
              <img src="@/static/images/interview-2-3.png" />
            </div>
            <div class="pcRight">
              <div class="top">面试流畅无卡顿</div>
              <div class="font-16">
                视频通话低延时，高质量<br />
                在全球部署视频服务器，流畅无卡顿<br />
                系统支持5万人高并发同时在线面试
              </div>
            </div>
          </div>
          <div class="list animated fadeInRight slow">
            <div class="left">
              <img src="@/static/images/interview-2-4.png" />
            </div>
            <div class="pcRight">
              <div class="top">面试数据实时分析</div>
              <div class="font-16">
                监控平台实时显示每场面试的进程数据<br />
                所有面试候选人、面试官面试进展<br />
                实时调控面试官，避免候选人等待
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="characteristic-mobile">
        <div class="animated fadeInDown slow">
          <div class="title">特色面试功能</div>
          <div class="subtitle">简单、易用的面试助手</div>
        </div>
        <div class="lists">
          <div class="list animated fadeInLeft slow">
            <img src="@/static/images/interview-2-1.png" />
            <div class="top">无需安装任何软件</div>
            <div class="font-16">
              面试官和候选人都无需安装任何软件<br />
              直接打开链接或扫描二维码<br />
              即可进入面试房间
            </div>
          </div>
          <div class="list animated fadeInRight slow">
            <img src="@/static/images/interview-2-2.png" />
            <div class="top">一键自助安排面试</div>
            <div class="font-16">
              面试后台一键导入面试名单<br />
              批量安排候选人，批量设置面试规则<br />
              无缝对接简历系统
            </div>
          </div>
          <div class="list animated fadeInLeft slow">
            <img src="@/static/images/interview-2-3.png" />
            <div class="top">面试流畅无卡顿</div>
            <div class="font-16">
              视频通话低延时，高质量<br />
              在全球部署视频服务器，流畅无卡顿<br />
              系统支持5万人高并发同时在线面试
            </div>
          </div>
          <div class="list animated fadeInRight slow">
            <img src="@/static/images/interview-2-4.png" />
            <div class="top">面试数据实时分析</div>
            <div class="font-16">
              监控平台实时显示每场面试的进程数据<br />
              所有面试候选人、面试官面试进展<br />
              实时调控面试官，避免候选人等待
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
  },
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  height: 100%;
  .inner {
    margin: auto;
    position: relative;
    top: -30px;
  }
}
.characteristic-box {
  width: 1200px;
  padding: 0px 0px 0px;
  margin: 0px auto;
  font-weight: 300;
  text-align: center;
  .title {
    font-size: 36px;
    padding: 20px 0px;
  }
  .subtitle {
    font-size: 16px;
  }
  .lists {
    text-align: left;
    display: inline-table;
    padding: 30px 0px 0px;
    .list {
      width: 50%;
      display: inline-flex;
      .left {
        padding: 20px;
        width: 26%;
        img {
          width: 100%;
        }
      }
      .right {
        padding: 20px 0px;
        .top {
          font-size: 24px;
          padding: 10px 0px;
        }
      }
      .pcRight {
        padding: 10px 0 0 20px;
        .top {
          font-size: 24px;
          padding: 10px 0px;
        }
      }
    }
  }
}
.characteristic-mobile {
  text-align: center;
  padding-top: 80px;
  color: #333;
  font-weight: 320;
  font-size: 24px;
  .subtitle {
    font-size: 12px;
    padding: 5px;
    color: #666;
  }
  .list {
    padding: 10px;
    .top {
      font-size: 18px;
      padding: 10px;
    }

    img {
      width: 40% !important;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .characteristic-mobile {
    .list {
      img {
        width: 45% !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/interview/characteristic.vue